import { FC, useCallback } from "react";

import { SegmentedControl } from "@tsmono/react/components";

export type ScoreView = "grid" | "chips";

interface ViewToggleProps {
  view: ScoreView;
  setView: (view: ScoreView) => void;
}

/**
 * Two-segment Grid / Chips toggle for the V2 score panel header.
 * Built on the shared `SegmentedControl` in compact (icon-only) mode.
 */
export const ViewToggle: FC<ViewToggleProps> = ({ view, setView }) => {
  const handleChange = useCallback(
    (id: string) => {
      if (id === "grid" || id === "chips") setView(id);
    },
    [setView]
  );
  return (
    <SegmentedControl
      compact
      selectedId={view}
      onSegmentChange={handleChange}
      segments={[
        { id: "grid", label: "Grid view", icon: "listView" },
        { id: "chips", label: "Chips view", icon: "gridView" },
      ]}
    />
  );
};
